module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Tablet 1x.26088b61.jpg";